<template>
  <div
    id="js-eventOnlineTable"
    class="eventOnlineTable"
    v-dragscroll.pass="!isTouchDevice()"
  >
    <table :style="tableWidth(type)" v-if="type == 'a'">
      <thead>
        <tr>
          <th class="eventOnlineTable_header_edge"></th>
          <th
            v-for="(time, index) in timeArray"
            :key="index"
            :class="nowOnAir(time, endTimeArray[index]) ? 'on-air' : ''"
          >
            {{ time }} ~ {{ endTimeArray[index] }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(channel, index) in editedChannels" :key="index">
          <th>
            <div class="eventsDetail_table_th_title">
              {{ channel.channel_name }}
            </div>
            <div class="eventsDetail_table_th_theme">
              {{ trimString(channel.channel_description) }}
            </div>
          </th>
          <td
            v-for="(program, index) in makeEmptyCell(channel.programs)"
            :key="index"
          >
            <EventDetailOnlineTableCellLabels
              :currentDate="currentTime"
              :eventDate="eventDay"
              :programLabels="'label' in program ? program.label : []"
              :programStartTime="
                'start_hour' in program &&
                program.start_hour !== '' &&
                program.start_minute !== '' &&
                program.end_hour !== '' &&
                program.end_minute !== ''
                  ? `${program.start_hour}:${program.start_minute}`
                  : ''
              "
              :ProgramEndTime="
                'end_hour' in program &&
                program.start_hour !== '' &&
                program.start_minute !== '' &&
                program.end_hour !== '' &&
                program.end_minute !== ''
                  ? `${program.end_hour}:${program.end_minute}`
                  : ''
              "
            />
            <button
              type="button"
              v-if="'title' in program"
              :class="{ '-active': program.isEnable }"
              :disabled="!program.isEnable"
              @click="
                viewLive(
                  channel.channel_name,
                  'start_hour' in program &&
                    program.start_hour !== '' &&
                    program.start_minute !== '' &&
                    program.end_hour !== '' &&
                    program.end_minute !== ''
                    ? `${program.start_hour}:${program.start_minute}`
                    : program.start
                )
              "
            >
              {{ program.title }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <table :style="tableWidth(type)" v-if="type == 'b'">
      <thead>
        <tr>
          <th
            v-for="(time, index) in timeArray"
            :key="index"
            :class="nowOnAir(time, endTimeArray[index]) ? 'on-air' : ''"
          >
            {{ time }} ~ {{ endTimeArray[index] }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td
            v-for="(program, index) in makeEmptyCell(
              editedChannels[0].programs
            )"
            :key="index"
          >
            <EventDetailOnlineTableCellLabels
              :currentDate="currentTime"
              :eventDate="eventDay"
              :programLabels="'label' in program ? program.label : []"
              :programStartTime="
                'start_hour' in program &&
                program.start_hour !== '' &&
                program.start_minute !== '' &&
                program.end_hour !== '' &&
                program.end_minute !== ''
                  ? `${program.start_hour}:${program.start_minute}`
                  : ''
              "
              :ProgramEndTime="
                'end_hour' in program &&
                program.start_hour !== '' &&
                program.start_minute !== '' &&
                program.end_hour !== '' &&
                program.end_minute !== ''
                  ? `${program.end_hour}:${program.end_minute}`
                  : ''
              "
            />
            <div
              class="eventsDetail_table_hospital"
              v-if="'hospital_name' in program"
            >
              {{ program.hospital_name }}
            </div>
            <button
              type="button"
              v-if="'title' in program"
              :class="{ '-active': program.isEnable }"
              :disabled="!program.isEnable"
              @click="
                viewLive('', `${program.start_hour}:${program.start_minute}`)
              "
            >
              {{ trimString(program.title) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <table :style="tableWidth(type)" v-if="type == 'c'">
      <thead>
        <tr>
          <th class="eventOnlineTable_header_edge"></th>
          <th
            v-for="(time, index) in timeArray"
            :key="index"
            :class="nowOnAir(time, endTimeArray[index]) ? 'on-air' : ''"
          >
            {{ time }} ~ {{ endTimeArray[index] }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(channel, index) in editedChannels" :key="index">
          <th>
            {{ channel.channel_name }}
          </th>
          <td
            v-for="(program, index) in makeEmptyCell(channel.programs)"
            :key="index"
          >
            <EventDetailOnlineTableCellLabels
              :currentDate="currentTime"
              :eventDate="eventDay"
              :programLabels="'label' in program ? program.label : []"
              :programStartTime="
                'start_hour' in program &&
                program.start_hour !== '' &&
                program.start_minute !== '' &&
                program.end_hour !== '' &&
                program.end_minute !== ''
                  ? `${program.start_hour}:${program.start_minute}`
                  : ''
              "
              :ProgramEndTime="
                'end_hour' in program &&
                program.start_hour !== '' &&
                program.start_minute !== '' &&
                program.end_hour !== '' &&
                program.end_minute !== ''
                  ? `${program.end_hour}:${program.end_minute}`
                  : ''
              "
            />
            <div
              class="eventsDetail_table_hospital"
              v-if="'hospital_name' in program"
            >
              {{ program.hospital_name }}
            </div>
            <button
              type="button"
              v-if="'title' in program"
              :class="{ '-active': program.isEnable }"
              :disabled="!program.isEnable"
              @click="
                viewLive(
                  channel.channel_name,
                  `${program.start_hour}:${program.start_minute}`
                )
              "
            >
              {{ trimString(program.title) }}
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, PropType } from 'vue'
import { onBeforeRouteLeave } from 'vue-router'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import 'dayjs/locale/ja'
dayjs.locale('ja')
dayjs.extend(isBetween)
import ScrollHint from 'scroll-hint'
import '../../../node_modules/scroll-hint/css/scroll-hint.css'
import { isTouchDevice } from '@/utils/commonMethods'
import { isNowBetweenTwoTimeString } from '@/utils/eventDetailOnlineTableUtils'
import EventDetailOnlineTableCellLabels from './EventDetailOnlineTableCellLabels.vue'

import {
  EventDetailOnlineChannel,
  EventDetailOnlineProgram
} from '@/types/EventDetail'

export default defineComponent({
  name: 'EventDetailOnlineTable',
  components: {
    EventDetailOnlineTableCellLabels
  },
  props: {
    type: String,
    eventDay: {
      type: String, // YYYY-MM-DD HH:mm:ss
      default: ''
    },
    currentTime: {
      type: String, // YYYY-MM-DD HH:mm
      default: ''
    },
    channels: {
      type: Array as PropType<EventDetailOnlineChannel[]>,
      default: () => []
    },
    hospitals: {
      type: Object,
      default: () => ({})
    },
    viewLive: {
      type: Function as PropType<
        (
          channelName: string,
          selectedProgramStart: string,
          btnType?: string
        ) => void
      >,
      required: true
    }
  },
  setup(props) {
    const scrollAnime = onMounted(() => {
      new ScrollHint('.eventOnlineTable', {
        i18n: {
          scrollable: '横スクロールで表示'
        }
      } as any)
    })

    // NOTE: ヘッダーを構成するためtimeHeaderItems: TimeHeaderItem[]を用意して、
    // 事前にtimeとnowOnAirの情報を詰める→高階関数をやめる
    const nowOnAir = computed(() =>
      isNowBetweenTwoTimeString(props.currentTime, props.eventDay)
    )

    const timeArray = computed(() => {
      if (!props.channels.length) return []
      const array: string[] = []
      props.channels.forEach((channel) => {
        if (!channel.programs.length) return
        channel.programs.forEach((program) => {
          if (
            !array.includes(`${program.start_hour}:${program.start_minute}`)
          ) {
            array.push(`${program.start_hour}:${program.start_minute}`)
          }
        })
      })
      array.sort((a: string, b: string) => {
        return Number(a.replace(':', '')) - Number(b.replace(':', ''))
      })
      return array
    })

    const endTimeArray = computed(() => {
      if (!props.channels.length) return []
      const array: string[] = []
      props.channels.forEach((channel) => {
        if (!channel.programs.length) return
        channel.programs.forEach((program) => {
          if (!array.includes(`${program.end_hour}:${program.end_minute}`)) {
            array.push(`${program.end_hour}:${program.end_minute}`)
          }
        })
      })
      array.sort((a: string, b: string) => {
        return Number(a.replace(':', '')) - Number(b.replace(':', ''))
      })
      return array
    })

    const editedChannels = computed(() => {
      if (!props.channels.length || !props.eventDay) return []

      const res: EventDetailOnlineChannel[] = []
      props.channels.forEach((channel) => {
        const temp: EventDetailOnlineChannel = {
          channel_name: channel.channel_name,
          channel_description: channel.channel_description,
          programs: []
        }
        // 番組の終了状態を把握する関数
        if (channel.programs && channel.programs.length) {
          temp.programs = channel.programs.map((program) => {
            const now = dayjs(props.currentTime)
            const eventYYYYMMDD = props.eventDay.split(' ')[0]
            const pEnd = dayjs(
              `${eventYYYYMMDD} ${program.end_hour}:${program.end_minute}`
            )

            program.isEnable = now.isBefore(pEnd)

            if (!program.hospital_id)
              program.hospital_name = 'マイナビRESIDENT運営事務局'
            if (props.hospitals[program.hospital_id])
              program.hospital_name =
                props.hospitals[program.hospital_id].hospital_name

            return program
          })
        }
        res.push(temp)
      })
      return res
    })

    const tableWidth = (type: string) => {
      const thWidth = type !== 'b' ? 172 : 0
      return {
        width: 210 * timeArray.value.length + thWidth + 'px'
      }
    }

    // 時刻のthセルに各tdセルの縦をあわせるための処理。channel.programsを引数に受け取り、ずらす分だけ空の中身を追加する
    const makeEmptyCell = (
      items: EventDetailOnlineProgram[]
      // ここで空オブジェクトの可能性があるせいでうまくいかん
    ): Array<EventDetailOnlineProgram | {}> => {
      const resultArray: {}[] = []
      // 全プログラムをmapでまわしてstartを取得した配列作る
      const itemStartArray = items.map(
        (x) => `${x.start_hour}:${x.start_minute}`
      )
      // timeArrayをまわしてstartと一致するものがなければ空セルをpush
      timeArray.value.forEach((time: string) => {
        if (itemStartArray.includes(time)) {
          const tartgetIndex = itemStartArray.indexOf(time)
          resultArray.push(items[tartgetIndex])
        } else {
          resultArray.push({})
        }
      })
      return resultArray
    }

    const trimString = (str: string): string => {
      const number = 17
      return str.length > number ? str.substr(0, number) + '…' : str
    }

    onMounted(() => {
      const table = document.querySelector('#js-eventOnlineTable')
      const tableHead = table?.querySelector('thead')
      let tableHeight = 0
      let tablePosition = 0
      let lastTime = 0

      const setTableInfo = () => {
        tableHeight = table ? table.clientHeight : 0
        tablePosition = table
          ? table.getBoundingClientRect().top + window.pageYOffset
          : 0
      }
      setTableInfo()

      const fixTableHeader = () => {
        const now = Date.now()
        if (now - lastTime < 10) return
        lastTime = now

        if (!tablePosition || !tableHeight) return

        if (
          window.pageYOffset >= tablePosition &&
          window.pageYOffset <= tablePosition + tableHeight
        ) {
          if (tableHead) {
            const diff = window.pageYOffset - tablePosition
            tableHead.style.top = diff + 'px'
          }
        } else {
          tableHead?.setAttribute('style', '')
        }
      }

      document.addEventListener('scroll', fixTableHeader)
      window.addEventListener('resize', setTableInfo)

      onBeforeRouteLeave(() => {
        document.removeEventListener('scroll', fixTableHeader)
        window.removeEventListener('resize', setTableInfo)
      })
    })

    return {
      scrollAnime,
      timeArray,
      endTimeArray,
      editedChannels,
      tableWidth,
      makeEmptyCell,
      trimString,
      nowOnAir,
      isTouchDevice
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
.eventOnlineTable {
  margin-top: 40px;
  overflow-x: auto;
  margin-bottom: 56px;
  padding-top: 40px;
  position: relative;
  cursor: grab;

  &:active {
    cursor: grabbing;
  }

  table {
    border-spacing: 0;
    margin-bottom: 24px;

    th,
    td {
      border-right: 1px solid var.$color-border-gray;
      border-bottom: 1px solid var.$color-border-gray;
      font-weight: normal;
      line-height: 1.5;
    }

    thead {
      position: absolute;
      top: 0;
      z-index: 2;

      tr {
        display: flex;
      }

      th {
        background-color: var.$color-other-bg;
        padding: 6.5px 16px 11.5px;
        width: 210px;
        height: 40px;
        border-top: 1px solid var.$color-border-gray;

        &:first-child {
          border-left: 1px solid var.$color-border-gray;
        }
        &.eventOnlineTable_header_edge {
          width: 172px;
        }
        &.on-air {
          background: var.$color-primary;
          color: #fff;
        }
      }
    }

    tbody {
      th {
        width: 172px;
        padding: 16px;
        text-align: left;
        background-color: #fff;
        border-left: 1px solid var.$color-border-gray;

        .eventsDetail_table_th_title {
          font-size: 11px;
          margin-bottom: 5px;
        }
      }
      td {
        padding: 20px 16px;
        width: 210px;
        vertical-align: top;

        .eventsDetail_table_label {
          font-size: 10px;
          line-height: 1;
          padding: 4px;
          background-color: var.$color-secondary;
          display: inline-block;
          margin-bottom: 10px;
          margin-right: 5px;
        }
        .eventsDetail_table_hospital {
          margin-top: -2.7px;
          font-size: 11px;
          margin-bottom: 7.3px;
        }
        button {
          display: block;
          text-align: left;
          margin: -3.5px 0;

          &:disabled {
            pointer-events: none;
          }

          &.-active {
            color: var.$color-main-text;

            &::after {
              margin-left: 11px;
              content: '';
              display: inline-block;
              width: 8px;
              height: 8px;
              border-top: 2px solid var.$color-main;
              border-right: 2px solid var.$color-main;
              transform: rotate(45deg);
            }
          }
        }
      }
    }

    thead th.eventOnlineTable_header_edge,
    tbody th {
      position: sticky;
      left: 0;
      z-index: 1;
    }
  }
}

::v-deep(.scroll-hint-icon-wrap) {
  z-index: 3;
}

::v-deep(.scroll-hint-icon) {
  width: 130px;
  height: 110px;
  padding: 35px 0 10px;
  background-color: rgba(41, 204, 195, 0.9);
}

::v-deep(.scroll-hint-text) {
  font-size: 11px;
  font-weight: 700;
}
</style>
